document.addEventListener('DOMContentLoaded', function () {

  // Selectors to apply Title Case to — add/remove as needed
  var selectors = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    '.product-title',
    '.card__heading',
    '.button',
    'button',
    '.header__inline-menu a',
    '.footer-block__heading',

    // Product card elements (Horizon)
    '.card',
    '.card-information',
    '.card__content',
    '.card__heading a',
    '.product-card',
    '.product-card__title'
  ];

  function toTitleCase(text) {
    return text
      .toLowerCase()
      .replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
  }

  // Walks only actual text nodes inside an element,
  // so icons/SVGs/nested tags inside buttons etc. aren't touched
  function applyTitleCase(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim().length > 0) {
        node.textContent = toTitleCase(node.textContent);
      }
    }
  }

  selectors.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(applyTitleCase);
  });

});